import React from "react";
import triangleImage from "../../assets/images/triangle.png";

export default function AlertIcon({ event, title, animationClass, width = 30, height = 30 }) {
    return (
        <div className={animationClass}>
            <img
                src={triangleImage}
                width={animationClass === "alerta-triangulo-visualizado" ? Math.round(width * 0.72) : width}
                height={animationClass === "alerta-triangulo-visualizado" ? Math.round(height * 0.72) : height}
                title={title}
                alt={title}
                onClick={event}
            />
        </div>
    );
}
